import {Component, EventEmitter, Input, Output} from '@angular/core';
import {IconType, IoniconsOutline, NavItem} from '@pt/pt-models';
import {PrimatooModule} from "it/primatoo/openapi/api/org/schemas/common/PrimatooModule";
import { SystemService } from '@pt/api-client';

@Component({
  selector: 'pt-no-active-module',
  templateUrl: './no-active-module.component.html',
  styleUrls: ['./no-active-module.component.scss']
})
export class NoActiveModuleComponent {

  @Input() primatooModule: PrimatooModule;

  @Output() clickAction = new EventEmitter<NavItem>();

  IconType = IconType;
  PrimatooModule = PrimatooModule;

  IconOpen = IoniconsOutline.mail;

  email?: string;
  constructor(private systemService: SystemService) {
    this.systemService.getSupportInfo().subscribe((success) => {
      this.email = success.email
    }, () => {
      this.email = undefined;
    })
  }
}
